module.exports = __webpack_public_path__ + "static/media/order-failure.74fccca0.svg";